// 公共埋点事件1
const buriedPoint = (code, data) => {
  const arg = [code, 'CLK']
  if (data) {
    arg.push(data)
  }
  window.$ztDataAction.push({
    action: 'aplus.record',
    arguments: arg
  })
}
export { buriedPoint }
